var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appHeader"},[_c('div',{staticClass:"d-flex flex-column justify-start align-start"},[_c('h1',{staticClass:"font-weight-black white--text appHeader__title text-capitalize"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-breadcrumbs',{staticClass:"text-white mr-3",attrs:{"items":_vm.appConfig.breadcrumb,"dark":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72d32bc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/AppHeader.vue
// module id = null
// module chunks = 